import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PriceCartService } from './price-cart.service';
import { LOV_PROPOSE_ALTERNATIVES, LovService } from '../../../shared/services/lov.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { ICodeValue } from '../../../../type_definitions/datatypes';
import { UntypedFormGroup } from '@angular/forms';
import { FormattingService } from '../../../shared/services/formatting.service';
import * as _ from 'underscore';

@Component({
  selector: 'propose-alternatives',
  template: `
    <div class="alert alert-warning propose-alternatives-warning" role="alert">
      <div><i class="fa fa-exclamation-triangle"></i>Many OEMs are experiencing global product constraints. Would you like us to quote alternative(s) if one or more of the items have a very long lead time?</div>
      <formly [form]="form" [fields]="fields" [model]="model" [noValidate]="true" class="propose-alternatives-form"></formly>
    </div>
  `,
  styleUrls: [ 'propose-alternatives.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class ProposeAlternativesComponent implements OnInit {

  public fields:IExtraFieldConfigurationObject[];
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public model:{
    proposeAlternativesOption?:ICodeValue
  };

  constructor(
    private priceCartService:PriceCartService,
    private formlyService:GaFormlyService,
    private lovService:LovService,
    private formattingService:FormattingService
  ) {
    /***/
  }

  public ngOnInit():void {
    const proposeAlternativesField:IExtraFieldConfigurationObject =
      this.formlyService.aRadio('proposeAlternativesOption')
        .withoutWrapper()
        .withFormat(this.formattingService.formatLov)
        .onChange(this.onProposeAlternativesChange)
        .build();

    this.fields = [ proposeAlternativesField ];
    this.formlyService.fillField(proposeAlternativesField, this.lovService.list(LOV_PROPOSE_ALTERNATIVES))
      .then(() => {
        this.model = {
          proposeAlternativesOption: _.find(proposeAlternativesField.templateOptions.options, (option:ICodeValue) => option.id === this.priceCartService.proposeAlternativesOption())
        };
      });
  }

  private onProposeAlternativesChange = () => {
    this.priceCartService.proposeAlternativesOption(this.model.proposeAlternativesOption?.id);
  };
}